import React from 'react'

import type { Props } from './types'

import { ImageMedia } from './ImageMedia'
import { VideoMedia } from './VideoMedia'

export const Media: React.FC<Props> = (props) => {
  const { className, htmlElement = 'div', resource, quality, fetchPriority, sizes, loading } = props

  const isVideo = typeof resource === 'object' && resource?.mimeType?.includes('video')

  // Pass optimization props to ImageMedia
  // Default to low fetch priority and lazy loading for non-explicit usages
  const optimizedProps = {
    ...props,
    quality,
    fetchPriority: fetchPriority ?? 'low',
    sizes,
    loading: loading ?? 'lazy',
  }

  if (htmlElement === null) {
    return isVideo ? <VideoMedia {...optimizedProps} /> : <ImageMedia {...optimizedProps} />
  }

  const Tag = htmlElement as React.ElementType
  const mediaNode = isVideo ? (
    <VideoMedia {...optimizedProps} />
  ) : (
    <ImageMedia {...optimizedProps} />
  )

  return React.createElement(Tag, { className }, mediaNode)
}
